import { render, staticRenderFns } from "./code_block_highlighted.vue?vue&type=template&id=f1ae75cc"
import script from "./code_block_highlighted.vue?vue&type=script&lang=js"
export * from "./code_block_highlighted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports